let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fWDs2")).then(() => parcelRequire('86TZ1'));